export default __webpack_public_path__ + "static/CtaNavBanner-946624ee3c0e67e15eb061310a749e86.png";